import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";

import microsoft from "../assets/img/microsoft.png";
import smartmessage from "../assets/img/smartmessage.png";
import cloudoffix from "../assets/img/cloudoffix.png";
import uconnect from "../assets/img/uconnect.png";
import touchforce from "../assets/img/touchforce.png";
import orbit from "../assets/img/partner-orbit.png";
import exotel from "../assets/img/exotel.jpg";

import "../assets/css/BusinessPartners.css";

const BusinessPartners = () => {
  const [show, setShow] = useState(false);

  const partners = [
    {
      category: "Cloud & Productivity",
      title: "Office 365 and Dynamics 365, built into every deployment.",
      description:
        "Outcess leverages Microsoft's enterprise cloud platform including Microsoft 365, Dynamics 365, Exchange, SharePoint, Teams, and OneDrive to deliver secure, scalable solutions. By integrating with the Microsoft tools your team already relies on, we help reduce complexity, accelerate deployment, and drive user adoption.",
      image: microsoft,
      reverse: false,
    },
    {
      category: "Marketing Automation",
      title: "The engine behind Outcess Omni-Channel Marketing.",
      description:
        "Powered by SmartMessage, we deliver enterprise-grade omnichannel marketing solutions that help businesses connect with customers through personalized, automated campaigns across email, SMS, mobile, and other digital channels all on a trusted platform with nearly 20 years of innovation.",
      image: smartmessage,
      reverse: true,
    },
    {
      category: "Contact Center Platform",
      title: "The omnichannel experience that never misses a beat, running seamlessly across every touchpoint.",
      description:
        "Powered by Exotel, we provide businesses with a secure, AI-driven contact center that supports voice, digital messaging, intelligent routing, smart dialers, and automated bots. We unify your entire customer interaction flow from self-service to agent resolution—so your teams can stay focused on building customer loyalty, not managing siloed tools.",
      image: exotel,
      reverse: false,
    },
    {
      category: "Enterprise Resource Planning (ERP)",
      title:
        "The unified business platform that doesn't drop the ball, running intelligently across your operations.",
      description:
        "Powered by CloudOffix, we provide businesses with a secure, AI-native platform that supports sales, marketing, project management, helpdesk, and HR by consolidating disconnected apps and siloed data. We manage your entire workflow from integration and custom app building to autonomous AI automation—so your teams can stay focused on driving growth, not managing software.",
      image: cloudoffix,
      reverse: true,
    },
    {
      category: "HR & BPO Consulting",
      title: "Nigerian HR expertise, headquartered where you are.",
      description:
        "U-Connect is a trusted human capital solutions provider with over two decades of experience in recruitment, outsourcing, payroll, training, and business process outsourcing. Together, Outcess and U-Connect help organizations attract, manage, and develop the talent they need to achieve their business goals.",
      image: uconnect,
      reverse: false,
    },
    {
      category: "Global Market Expansion",
      title:
        "Reach beyond Nigeria and West Africa, backed by real go-to-market expertise.",
      description:
        "TouchForce IT Solutions, headquartered in Dubai, helps businesses launch into new markets — go-to-market strategy, qualified lead generation, and enterprise partnerships across IoT, fintech, e-learning, and SaaS. As Outcess extends its reach beyond West Africa, TouchForce is the partner helping open those doors.",
      image: touchforce,
      reverse: true,
    },
  ];

  return (
    <div id="business-partners">
      <Navbar />

      {/* HERO */}

      <section className="bp-hero">
        <div className="container bp-hero-grid pb-3">
          <div className="bp-hero-content" data-aos="fade-right">
            <h1>
              Strong partnerships. Better
              <br /> solutions. Greater business outcomes.
            </h1>

            <p>
              Every solution we deliver is backed by trusted global and regional
              technology partners, ensuring our clients benefit from proven
              platforms, expert support, and future-ready innovation.
            </p>
          </div>

          <div className="bp-hero-image" data-aos="zoom-in">
            <img src={orbit} alt="" />
          </div>
        </div>
      </section>

      {/* WHY PARTNER */}

      <section className="bp-why">
        <div className="container" data-aos="fade-up">
          <span className="section-tag">WHY WE PARTNER</span>

          <h2>
            We Don't Reinvent the Platform. We Make It Work Harder.
          </h2>

          <p>
            No single organization has all the answers. That's why we work with
            trusted technology leaders to bring our clients the right mix of
            expertise, innovation, and enterprise-grade solutions. Every
            partnership is carefully selected to ensure we deliver measurable
            value, seamless integration, and long-term success.
          </p>
        </div>
      </section>

      {/* PARTNERS */}

      <section className="bp-partners">
        <div className="container">
          <div className="section-heading">
            <h2>Our Strategic Technology Partners</h2>

            <p>
              Every solution we deliver is backed by trusted global and regional
              technology partners, ensuring our clients benefit from proven
              platforms, expert support, and future-ready innovations.
            </p>
          </div>

          {partners.map((partner, index) => (
            <div
              key={index}
              className={`partner-row ${partner.reverse ? "reverse" : ""}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="partner-logo">
                <img src={partner.image} alt={partner.title} />
              </div>

              <div className="partner-content">
                <span>{partner.category}</span>

                <h3>{partner.title}</h3>

                <p>{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}

      <section className="bp-cta">
        <div className="container" data-aos="zoom-in">
          <h2>See how these partnerships come together in your solution.</h2>

          <p>
            Book a demo and we'll walk through exactly which platforms power
            what you need.
          </p>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Get in Touch
          </button>
        </div>
      </section>

      <RFQModal show={show} setShow={setShow} />
      <Footer />
    </div>
  );
};

export default BusinessPartners;
